if (!customElements.get('okendo-stars')) {
  class OkendoStars extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.okeWidgetApi?.initWidget(this, true);
      window.okeWidgetApi?.setProduct(
        this,
        this.getAttribute('data-product-id'),
      );
    }
  }
  customElements.define('okendo-stars', OkendoStars);
}
